/**
 * Represents different types of Aberrant Quantity. This enum extends values from
 */
export enum AberrantQuantityTypeModel {
	/**
	 * Indicates that the aberrant quantity is defined within a specific range (minimum and maximum values).
	 */
	Range = 1,
	/**
	 * Indicates that the aberrant quantity must match an exact value.
	 */
	Exactly = 2
}
